import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import QuoteBlock from "./QuoteBlock";
import { ParallaxBackground } from "./ParallaxImage";
import { HERO, IMAGES } from "../constants/config";
import SectionLink from "./SectionLink";
import { animationVariants, defaultViewport } from "../constants/animations";

function HeroSection() {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"],
  });

  const contentY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const contentOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <motion.section
      ref={sectionRef}
      id="home"
      className="relative -mt-[var(--nav-height)] flex min-h-screen w-full max-w-full flex-col justify-center overflow-hidden px-4 py-8 sm:px-6 sm:py-10 lg:px-10 xl:px-14 2xl:px-20"
      aria-label="Hero section"
      initial="hidden"
      whileInView="visible"
      viewport={defaultViewport}
    >
      <ParallaxBackground
        src={IMAGES.coverPhoto}
        alt="Tower infrastructure background"
        speed={35}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-indigo-950/90 via-indigo-900/75 to-indigo-900/50" />

      <motion.div
        style={{ y: contentY, opacity: contentOpacity }}
        className="relative z-10 mx-auto flex w-full max-w-[1800px] flex-col items-center gap-8 text-center md:gap-10"
        variants={animationVariants.staggerContainerSlow}
      >
        <motion.div
          className="flex w-full max-w-4xl flex-col items-center gap-5 md:gap-6"
          variants={animationVariants.slideUp}
        >
          <h1 className="text-balance text-3xl font-bold leading-tight text-white sm:text-4xl md:text-5xl lg:text-6xl">
            {HERO.title}
          </h1>

          <p className="max-w-2xl text-sm leading-relaxed text-indigo-100 sm:text-base md:text-lg">
            {HERO.subtitle}
          </p>

          <SectionLink
            sectionId={HERO.primaryCta.sectionId}
            className="inline-flex min-h-[48px] items-center justify-center rounded-lg bg-white px-6 py-3 text-sm font-bold text-indigo-900 transition-colors hover:bg-indigo-50 sm:text-base"
          >
            {HERO.primaryCta.label}
          </SectionLink>
        </motion.div>

        <motion.div
          className="w-full max-w-2xl"
          variants={animationVariants.scaleUp}
        >
          <QuoteBlock />
        </motion.div>
      </motion.div>
    </motion.section>
  );
}

export default HeroSection;
